var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page not-found"},[_c('div',[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.$parseEmoji(':cyclone:'))}}),_vm._v(" "),_c('p',[_vm._v("It seems what you are looking for isn't here. It may have vanished in the infinite void of the web.")]),_vm._v(" "),_c('VueButton',{staticClass:"accent",attrs:{"to":{ name: 'home' }}},[_vm._v("Get me out of here!")])],1)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49fb74ea","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/NotFound.vue
// module id = 540
// module chunks = 0